import { regions } from '@planner/config';

const formatters = new Map<string, Intl.NumberFormat>();

/**
 * Formats an amount in the order's own currency (orders from different market
 * regions appear in the same table, so the currency travels with the order,
 * not the build). Locale comes from the region config that owns the currency.
 */
export function formatCurrency(amount: number, currency: string): string {
  let formatter = formatters.get(currency);
  if (!formatter) {
    const locale = regions.find((region) => region.currency === currency)?.locale;
    formatter = new Intl.NumberFormat(locale, { style: 'currency', currency });
    formatters.set(currency, formatter);
  }
  return formatter.format(amount);
}
